const _version = "3.2.2"
function version() {
    return _version
}
export default version
